import { ReactElement } from "react";

export function Help(): ReactElement {
  return (
    <main className="py-8 flex flex-col lg:flex-row grow z-20">
      <h1 className="text-lg font-bold">Hilfe</h1>
    </main>
  );
}
